import { aiInterviewApi } from './ai-interview-api';
import { aiTutorApi } from './ai-tutor-api';
import { careerAdviceApi } from './career-advice-api';
import { personalizedLearningApi } from './personalized-learning-api';
import { smartCVApi } from './smart-cv-api';
import { talentHubApi } from './talent-hub-api';
import { taxApi } from './tax-api';

export type APIDetails = {
  tags?: string[];
  id: string;
  logo?: string;
  title: string;
  subtitle: string;
  description: string[];
  overview: string[];
  features: {
    title: string;
    description: string;
  }[];
  workflow: string[];
  endpoints: {
    category: string;
    items: {
      category: string;
      method: string;
      path: string;
      description: string;
    }[];
  }[];
  apiDocumentation: {
    title: string;
    method: string;
    path: string;
    requestPath?: string;
    description: string;
    requestExample?: Record<string, any>;
    responseExample: Record<string, any> | Record<string, any>[];
    parameters?: {
      name: string;
      type: string;
      required: boolean;
      description: string;
    }[];
    statusCode: string;
  }[];
  useCases: {
    title: string;
    description: string;
  }[];
  targetUsers: string[];
};

export const API_CATALOG: APIDetails[] = [
  {
    ...talentHubApi,
    tags: ['HRX'],
    logo: '/assets/api-details/TalentHub API.png',
  },
  {
    ...smartCVApi,
    tags: ['HRX'],
    logo: '/assets/api-details/Smart CV Analysis API.png',
  },
  {
    ...taxApi,
    tags: ['HRX'],
    logo: '/assets/api-details/Tax AI & Automation API.png',
  },
  {
    ...careerAdviceApi,
    tags: ['HRX', 'Somriddhi'],
    logo: '/assets/api-details/Career Content & Advice API.png',
  },
  {
    ...aiInterviewApi,
    tags: ['HRX', 'Somriddhi'],
    logo: '/assets/api-details/AI Interview API.png',
  },
  {
    ...aiTutorApi,
    tags: ['Somriddhi'],
    logo: '/assets/api-details/AI Tutor API.png',
  },
  {
    ...personalizedLearningApi,
    tags: ['Somriddhi'],
    logo: '/assets/api-details/Personalized Learning API.png',
  },
];
